import { departments } from '../data'

/**
 * Station keys for react-select: canonical order from `data.js` `departments`,
 * filtered by `me.entitledModules` (subscription / product modules from the API).
 * If entitlements are missing or empty, the full `departments` list is used (legacy API).
 */
export function getStationSelectOptions(entitledModules) {
    const hasEntitlements =
        Array.isArray(entitledModules) && entitledModules.length > 0

    const keys = hasEntitlements
        ? departments.filter((d) => entitledModules.includes(d))
        : departments

    return keys.map((station) => ({
        type: 'station',
        label: station.replace(station[0], station[0].toUpperCase()),
        value: station,
        permissions: [],
    }))
}
